import React, { Component, Fragment } from 'react';
import './Card.Module.scss';
import Modal from 'react-responsive-modal';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import { faBolt, faChevronLeft, faCode, faHeart, faUsers, faUser, faClock, faCut, faDownload, faArrowToBottom } from '@fortawesome/pro-solid-svg-icons';

import {faHeart as faHeartRegular,} from '@fortawesome/pro-regular-svg-icons';

import{ faTimes as faTimesLight} from '@fortawesome/pro-light-svg-icons';

import {cardData} from 'utilities/card';
import Table1 from '../DeCultureleLadekast/DeCultureleLadekast';
import DeCultureleLadekast from '../DeCultureleLadekast/DeCultureleLadekast';
import CultuurStation from '../CultuurStation/CultuurStation';
import SLO from '../SLO/SLO';

import CardPopup from '../CardPopup/CardPopup'
import HeartButton from '../HeartButton/HeartButton';

class Card extends Component {

    constructor() {
        super();
        this.state = {
            dropdownValue: 'ladekast'
        }

        this.handleChange = this.handleChange.bind(this);
        this.getTags = this.getTags.bind(this);
        this.childClick = this.childClick.bind(this);
    }


    childClick(){
        this.props.parentFunctie(this.props.card.id);
    }
    
    //scroll to top
    componentDidUpdate() {
        window.scrollTo(0,0);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }

    handleChange(e) {
        let {value} = e.target;
        this.setState({
            dropdownValue: value
        });
    }

    nl2br (str, is_xhtml) {
        // http://kevin.vanzonneveld.net
        // +   original by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   improved by: Philip Peterson
        // +   improved by: Onno Marsman
        // +   improved by: Atli Þór
        // +   bugfixed by: Onno Marsman
        // +      input by: Brett Zamir (http://brett-zamir.me)
        // +   bugfixed by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
        // +   improved by: Brett Zamir (http://brett-zamir.me)
        // +   improved by: Maximusya
        // *     example 1: nl2br('Kevin\nvan\nZonneveld');
        // *     returns 1: 'Kevin<br />\nvan<br />\nZonneveld'
        // *     example 2: nl2br("\nOne\nTwo\n\nThree\n", false);
        // *     returns 2: '<br>\nOne<br>\nTwo<br>\n<br>\nThree<br>\n'
        // *     example 3: nl2br("\nOne\nTwo\n\nThree\n", true);
        // *     returns 3: '<br />\nOne<br />\nTwo<br />\n<br />\nThree<br />\n'
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br ' + '/>' : '<br>'; // Adjust comment to avoid issue on phpjs.org display
      
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      }

    getTags(tags) {
        var tagArray = [];
        var extraTags = 0;

        if(!tags) {
            return [];
        }

        for (var i = 0; i < tags.length; i++) {
            if(i < 2) {
                tagArray.push(tags[i]);
            }
            else {
                extraTags++;
            }
        }

        extraTags > 0 && tagArray.push('+' + extraTags);

        return tagArray;
    }



    render() {
        var { card } = this.props;
        let type = card.type;

        if(type == 'workshopcard' || type == 'eventcard' || type == 'artcard') {
            type = 'workshopcard';
        } else {
            type = 'card';
        }

        let slug = card.name.split(" ").join("-").toLowerCase();

        let cardColor;
        switch (card.level.toLowerCase()) {
            case 'intro':
                cardColor = '#FF3956';
                break;
            case 'basis':
                cardColor = '#FFCD2E';
                break;
            case 'gevorderd':
                cardColor = '#38D7D7';
                break;
            case 'expert':
                cardColor = '#6F3BFF';
                break;
        }
        return (
        <Fragment>
            
            <div styleName={`${(type ? type : 'card')}-wrapper`} onClick={this.childClick}>
                <div styleName='background-image' style={{backgroundImage: `url(/storage/${card.image})` , backgroundColor:`${cardColor}`, height: `${this.props.exampleLine ? '215px' : null }`}}>
                    <p styleName='mu-label' style={{display:`${card.bymu}`, backgroundColor:`${cardColor}`}}>{card.label} <b>{card.author}</b></p>
                    {
                                        card.type == 'workshopcard' &&
                                    
                            <div styleName='circle-heart'>
                                <div styleName='icon'>
                                    <HeartButton id={card.id}/>
                                </div>
                            </div>
                            }
                    <div styleName='content-wrapper'>
                    <h1 styleName='h1-workshop'>{card.type == 'eventcard' ? 'EVENT' : 'WORKSHOP'}</h1>
                    <h1 style={this.props.exampleLine ? { bottom: '128px'} : null} styleName='h1-workshopcard'>{card.name}</h1>
                    <div styleName='test-wrapper'>
                    <h3>Code &#38; techniek</h3>
                    <div styleName='technisch-bar'>
                        <div styleName='technisch-bar-content' style={{ width: `${card['code-tech-percentage'] * 10}%` , backgroundColor:`${cardColor}`}}>
                        
                        </div>
                    </div>
                    <h3>Kunst &#38; Creativiteit</h3>
                    <div styleName='creative-bar'>
                        <div styleName='creative-bar-content' style={{ width: `${card['art-creativity-percentage'] * 10}%` , backgroundColor:`${cardColor}`}}>
                        
                        </div>
                    </div>
                    <h3>Kritisch denken</h3>
                    <div styleName='filosofisch-bar'>
                        <div styleName='filosofisch-bar-content' style={{ width: `${card['critical-thinking-percentage'] * 10}%` , backgroundColor:`${cardColor}`}}>
                        
                        </div>
                    </div>
                    { !this.props.exampleLine &&
                    <Fragment>
                        <div styleName='label-wrapper'>
                            <div styleName='circle'>
                                <div styleName='icon' >
                                <FontAwesomeIcon  style={{width:'12px'}} icon={faCode}/>
                                </div>
                            </div>
                            {this.getTags(card.tags).map((tag, index) => <p key={index}>{tag}</p>)}
                        </div>
                        <div styleName='icon-wrapper'>
                            <div styleName='icons-left'>
                                {
                                    card.plugged ?
                                
                                <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                    <div styleName='icon'>
                                    <FontAwesomeIcon icon={faBolt}/>
                                    </div>
                                </div>
                                :
                                <div styleName='circle'style={{backgroundColor:`${cardColor}`}}>
                                    <div styleName='icon'>
                                    <FontAwesomeIcon icon={faCut}/>
                                    </div>
                                </div>
                                }
                                {
                                    card.group_lesson ?
                                
                                    <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                        <div styleName='icon'>
                                        <FontAwesomeIcon icon={faUsers}/>
                                        </div>
                                    </div>
                                    : null
                                }
                                {
                                    card.individual_lesson ?
                                
                                    <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                        <div styleName='icon'>
                                        <FontAwesomeIcon icon={faUser}/>
                                        </div>
                                    </div>
                                    : null
                                }
                                <div styleName='circle' style={{backgroundColor:`${cardColor}`}}>
                                    <div styleName='icon'>
                                    <p>
                                        <FontAwesomeIcon icon={faClock}/> {card.time_min} {card.time_min != card.time_max ? `- ${card.time_max}` : ''} min
                                    </p>
                                    </div>
                                </div>
                            </div>
                            <div styleName='icons-right'>
                                {type == 'card' &&
                                    <HeartButton id={card.id}/>
                                }
                            </div>
                        </div>
                    </Fragment>
                    }
                </div>
                </div>
                </div>
            </div>
        </Fragment>
        );
    }
}

export default Card;
